import { combineReducers } from 'redux'
import liveClasses from './ducks/liveclass'
import activation from './ducks/activation'
import taskdelivery from './ducks/taskdelivery'
import discipline from './ducks/discipline'
import certificate from './ducks/certificate'

export default combineReducers({
  liveClasses,
  activation,
  discipline,
  certificate,
  taskdelivery
})
